module.exports = __webpack_public_path__ + "assets/img/ttl-seminar.svg";